import { writable } from "svelte/store";
export const publication_items = writable([]);
export const preview_image = writable({
    base64: '',
    name: ''
});
